import { render, staticRenderFns } from "./table1.vue?vue&type=template&id=7f66d2ac&scoped=true&"
import script from "./table1.vue?vue&type=script&lang=js&"
export * from "./table1.vue?vue&type=script&lang=js&"
import style0 from "./table1.vue?vue&type=style&index=0&id=7f66d2ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f66d2ac",
  null
  
)

export default component.exports